 import * as variables from './variables.js';

import './lib/AnimationEasing';
import 'es6-promise/auto';
import 'whatwg-fetch';

// Polyfills
declare function require(name:string): any;
require('./polyfill/matches.js'); /* IE 11 */
require('./polyfill/closest.js'); /* IE 11 */

import {Analytics} from '@plaudit/analytics';
Analytics.getInstance();

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);
const browserInfo = DetectBrowser.getInfo();

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import {MainMenu, CollapseExpandChildrenListener } from './component/MainMenu/MainMenu';
const animationUnsupported = browserInfo.android && browserInfo.android.browserVersion === 4.0;
const mainMenu = new MainMenu({
	menu: '#menu',
	menuTriggers: '.menuTrigger--open, .menuTrigger--close, .pageOverlay',
	nodeTrigger: '.node--hasChild > a',
	styleClass: {
		menuOpen: 'hasMenuOpen',
		nodeOpen: 'isOpen'
	},
	listeners: [
		new CollapseExpandChildrenListener(animationUnsupported ? 0 : 400, 'easeOutExpo')
	]
});

// Adds classes to body as we scroll
import Scrolled from './component/Scrolled';
new Scrolled({
	scrolledClass: 'hasScrolled',
	scrolledDistanceClass: 'hasScrolledDistance',
	scrollDistanceDown: 200,
	scrollDistanceUp: 20
});

import Forms from './component/Forms';
Forms.init();

import featureCarousel from './component/FeatureCarousel';
const entryCarouselEl = document.querySelector('.__entry .featureCarousel') as HTMLElement;
if (entryCarouselEl) {
	const entryCarousel = new featureCarousel({
		analyticsCategory: 'Feature Carousel',
		carouselClass: 'featureCarousel',
		carouselEl: entryCarouselEl,
		duration: 2000
		// doIndicatorClick: true,
	});
}

import AutoLoadItems from './lib/AutoLoadItems';
new AutoLoadItems({
	frameId: 'newsList',
	nextClass: 'btn--next',
	resultsClass: 'newsListItem',
	paginationClass: 'pagination',
	loadMoreButtonText: '<span class="plusBox"></span> Load More News'
});